//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"AxisProximityObject",1,"Axis",0],[1,"EndRange",0,"Expression",0],[0,"FindType",1,0],[0,"ObjectType",1,0],[0,"PlanarProximityObject",1,"Plane",0],[1,"StartRange",0,"Expression",0],[0,"WithinRange",1,0]],[],[]];
SPLM.Features.SelectionProgramObjectTypeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SelectionProgramObjectTypeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SelectionProgramObjectTypeBuilder.ObjectTypes = Object.freeze({
    "CylindricalFace" : "CylindricalFace", "ConvexBlendFace" : "ConvexBlendFace", "ConcaveBlendFace" : "ConcaveBlendFace", "BlendFace" : "BlendFace", "ConicalFace" : "ConicalFace", "BSurfaceFace" : "BSurfaceFace", "ForeignFace" : "ForeignFace", "OffsetFace" : "OffsetFace", "PlanarFace" : "PlanarFace", "RevolvedFace" : "RevolvedFace", "SphereFace" : "SphereFace", "TorusFace" : "TorusFace", "SolidBody" : "SolidBody", "SheetBody" : "SheetBody", "ConvergentBody" : "ConvergentBody"});

SPLM.Features.SelectionProgramObjectTypeBuilder.FindTypes = Object.freeze({
    "All" : "All", "Coaxial" : "Coaxial", "AllConvexFace" : "AllConvexFace", "AllConcaveFace" : "AllConcaveFace", "Coplanar" : "Coplanar", "Parallel" : "Parallel", "Perpendicular" : "Perpendicular", "WithinRange" : "WithinRange"});

export default SPLM;